import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NodeCache = require("node-cache");
var PersonalityDataService = /** @class */ (function () {
    function PersonalityDataService(http) {
        this.http = http;
        this.myCache = new NodeCache();
    }
    PersonalityDataService.prototype.getBaseUrl = function () {
        return environment.baseUrl;
    };
    PersonalityDataService.prototype.getUrl = function (relativeUrl) {
        return this.getBaseUrl() + relativeUrl;
    };
    PersonalityDataService.prototype.getOptions = function () {
        var AuthorizeToken = localStorage.getItem('USER_TOKEN');
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + AuthorizeToken
        });
        var options = {
            headers: headers
        };
        return options;
    };
    PersonalityDataService.prototype.getQueryTwo = function (discType) {
        var url = this.getUrl('/personality-data/query2/' + discType);
        return this.http.get(url, this.getOptions())
            .pipe(map(function (response) {
            return response;
        }));
    };
    PersonalityDataService.prototype.getQueryOne = function (discType) {
        var url = this.getUrl('/personality-data/query1/' + discType);
        return this.http.get(url, this.getOptions())
            .pipe(map(function (response) {
            return response;
        }));
    };
    PersonalityDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PersonalityDataService_Factory() { return new PersonalityDataService(i0.ɵɵinject(i1.HttpClient)); }, token: PersonalityDataService, providedIn: "root" });
    return PersonalityDataService;
}());
export { PersonalityDataService };
